<div class="grid grid-cols-3 gap-4 pb-3">
	@if(Helper.getLanguage() === 'ar'){
		<div class="col-span-2">
			@switch (_osSelected) {
			@case ("macos") {
			<img src="./assets/images/os/mac.png" alt="">
			}
			@case ("ios") {
			<img src="./assets/images/os/ios.png" alt="">
			}
			@case ("windows") {
			<img src="./assets/images/os/windows.png" alt="">
			}
			@case ("android") {
			<img src="./assets/images/os/android.png" alt="">
			}
			@default {
			<span class="font-source_extralight text-text-blue">{{'instructions.no' | translate}}</span>
			}
			}
		</div>
		<div class="" [ngClass]="{'text-right': Helper.getLanguage() === 'ar', 'unicode-bidi':Helper.getLanguage() === 'ar', 'text-left': Helper.getLanguage() !== 'ar'}">
			<h1 class="text-2xl font-source_extralight text-text-blue">{{'instructions.checkOS' | translate}}</h1>
			<span class="font-source_extralight pb-2 text-text-light_blue underline hover:cursor-pointer"
				(click)="openModal()">{{'instructions.changeOS' | translate}}</span>
		</div>
	}@else{
	<div class="col-span-2">
		<h1 class="text-2xl font-source_extralight text-text-blue">{{'instructions.checkOS' | translate}}</h1>
		<span class="font-source_extralight pb-2 text-text-light_blue underline hover:cursor-pointer"
			(click)="openModal()">{{'instructions.changeOS' | translate}}</span>
	</div>
	<div>
		@switch (_osSelected) {
		@case ("macos") {
		<img src="./assets/images/os/mac.png" alt="">
		}
		@case ("ios") {
		<img src="./assets/images/os/ios.png" alt="">
		}
		@case ("windows") {
		<img src="./assets/images/os/windows.png" alt="">
		}
		@case ("android") {
		<img src="./assets/images/os/android.png" alt="">
		}
		@case ("linux") {
		<img src="./assets/images/os/osnt.png" alt="" class="w-250">
		}
		@default {
		<span class="font-source_extralight text-text-blue">{{'instructions.no' | translate}}</span>
		}
		}
	</div>
	}
</div>
<hr class="pt-3">
<!-- Modal -->
@if(_modalVisible){
<div class="fixed inset-0 flex items-center justify-center z-50 bg-slate-200">
	<div class="bg-white border-2 border-gray-100 rounded-lg p-8 w-[500px]">
		<button class="top-2 float-right text-gray-500 hover:text-gray-700" aria-label="Close" (click)="closeModal()">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
				class="w-6 h-6">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
			</svg>
		</button>
		<div class="grid grid-rows-4 gap-4">
			<div>
				<button class="flex items-center space-x-2" (click)="changeOS('macos')">
					<img src="./assets/images/os/mac.png" alt="Apple macOS" class="">
				</button>
			</div>
			<div>
				<button class="flex items-center space-x-2" (click)="changeOS('ios')">
					<img src="./assets/images/os/ios.png" alt="Apple iOS" class="">
				</button>
			</div>
			<div>
				<button class="flex items-center space-x-2" (click)="changeOS('windows')">
					<img src="./assets/images/os/windows.png" alt="Windows" class="">
				</button>
			</div>
			<div>
				<button class="flex items-center space-x-2" (click)="changeOS('android')">
					<img src="./assets/images/os/android.png" alt="Android" class="">
				</button>
			</div>
		</div>
	</div>
</div>
}
<div [ngClass]="{'text-right': Helper.getLanguage() === 'ar', 'unicode-bidi':Helper.getLanguage() === 'ar', 'text-left': Helper.getLanguage() !== 'ar'}">
	<p class="text-xl font-source_extralight text-text-blue">
		{{'how_to.intro' | translate}}
	</p>
</div>
<app-accordion [accordionItems]="[{ title: 'how_to.title_1' | translate }]" [ngClass]="{'text-right': Helper.getLanguage() === 'ar', 'unicode-bidi':Helper.getLanguage() === 'ar', 'text-left': Helper.getLanguage() !== 'ar'}">
	<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
		<div class="button flex flex-col items-center cursor-pointer" (click)="showContent('video_1')">
		  <img src="./assets/images/instructions/general/video.png" alt="video icon" class="w-12 h-12">
		  <div class="button-text mt-4 text-center">{{ 'install_instructions.icon.watch' | translate }}</div>
		</div>
		<div class="button flex flex-col items-center cursor-pointer" (click)="showContent('audio_1')">
		  <img src="./assets/images/instructions/general/microphone.png" alt="audio icon" class="w-12 h-12">
		  <div class="button-text mt-4 text-center">{{ 'install_instructions.icon.listen' | translate }}</div>
		</div>
		<div class="button flex flex-col items-center cursor-pointer" (click)="showContent('text_1')">
		  <img src="./assets/images/instructions/general/text.png" alt="text icon" class="w-12 h-12">
		  <div class="button-text mt-4 text-center">{{ 'install_instructions.icon.read' | translate }}</div>
		</div>
	  </div>
	<div>
		@switch (_valContent) {
			@case ("video_1") {
				<app-video-download [deviceOs]="_osSelected"></app-video-download>
			}
			@case ("audio_1") {
				<app-audio-download [deviceOs]="_osSelected"></app-audio-download>
			}
			@case ("text_1") {
				<app-instructions [deviceOs]="_osSelected"></app-instructions>
			}
		}
	</div>
</app-accordion>
<app-accordion [accordionItems]="[{ title: 'how_to.title_2' | translate }]" [ngClass]="{'text-right': Helper.getLanguage() === 'ar', 'unicode-bidi':Helper.getLanguage() === 'ar', 'text-left': Helper.getLanguage() !== 'ar'}">
	<!-- <app-install-instructions [deviceOs]="_osSelected"></app-install-instructions> -->
	<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
		<div class="button flex flex-col items-center cursor-pointer" (click)="showContent('video_2')">
		  <img src="./assets/images/instructions/general/video.png" alt="video icon" class="w-12 h-12">
		  <div class="button-text mt-4 text-center">{{ 'install_instructions.icon.watch' | translate }}</div>
		</div>
		<div class="button flex flex-col items-center cursor-pointer" (click)="showContent('audio_2')">
		  <img src="./assets/images/instructions/general/microphone.png" alt="audio icon" class="w-12 h-12">
		  <div class="button-text mt-4 text-center">{{ 'install_instructions.icon.listen' | translate }}</div>
		</div>
		<div class="button flex flex-col items-center cursor-pointer" (click)="showContent('text_2')">
		  <img src="./assets/images/instructions/general/text.png" alt="text icon" class="w-12 h-12">
		  <div class="button-text mt-4 text-center">{{ 'install_instructions.icon.read' | translate }}</div>
		</div>
	  </div>
	<div>
		@switch (_valContent) {
			@case ("video_2") {
				<app-video-install [deviceOs]="_osSelected"></app-video-install>
			}
			@case ("audio_2") {
				<app-audio-install [deviceOs]="_osSelected"></app-audio-install>
			}
			@case ("text_2") {
				<app-install-instructions [deviceOs]="_osSelected"></app-install-instructions>
			}
		}
	</div>
</app-accordion>
